import { Injectable } from "@angular/core";
import { Router } from '@angular/router';
import { HttpServices } from "./httpservices/http.service";
import { EmitService } from './emit.service';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';
@Injectable()

export class HomeService {

    constructor(private dataSource: HttpServices, public router: Router) {
    }

    goods: any = [];

    signin(username, password, organ): Observable<any> {
        return this.dataSource.signin(username, password, organ);
    }

    getUserOrgan(): Observable<any> {
        return this.dataSource.getUserOrgan();
    }

    checkOrg(username, password): Observable<any> {
        return this.dataSource.checkOrg(username, password);
    }

    getLastGoodsData(goodsList, date): Observable<any> {
        return this.dataSource.getLastGoodsData(goodsList, date);
    }

    getLastGoodsUpdateTime(): Observable<any> {
        return this.dataSource.getLastGoodsUpdateTime();
    }

    uploadFile(file, type): Observable<any> {
        return this.dataSource.uploadFile(file, type);
    }

    uploadImgs(data): Observable<any> {
        return this.dataSource.uploadImgs(data);
    }

    saveCustomData(date, goodsList): Observable<any> {
        return this.dataSource.saveCustomData(date, goodsList);
    }

    getDataByDateChange(myDates, goodsList): Observable<any> {
        return this.dataSource.getDataByDateChange(myDates, goodsList);
    }

    upload(data) {
        this.goods = data;
        console.log(this.goods)
    }

    download(type) {
        return this.dataSource.download(type);
    }

    searchGoods(goodsData, date): Observable<any> {
        return this.dataSource.searchGoods(goodsData, date);
    }

    getSelectedGoodsData(goodsIds, date): Observable<any> {
        return this.dataSource.getSelectedGoodsData(goodsIds, date);
    }

    getData(): Observable<any> {
        return this.dataSource.getData();
    }

    insertData(review, specialScore, scoreReview, isUpdate, id): Observable<any> {
        return this.dataSource.insertData(review, specialScore, scoreReview, isUpdate, id);
    }

    insertTable(type, data, doctorList, scoreSpecial, isUpdate, id, review, score): Observable<any> {
        return this.dataSource.insertTable(type, data, doctorList, scoreSpecial, isUpdate, id, review, score);
    }

    getDataSle(): Observable<any> {
        return this.dataSource.getDataSle();
    }

    getNewsDetail(id): Observable<any> {
        return this.dataSource.getNewsDetail(id);
    }

    getNoticeDetail(id): Observable<any> {
        return this.dataSource.getNoticeDetail(id);
    }

    moreNotice(page): Observable<any> {
        return this.dataSource.moreNotice(page);
    }


    getHospital(keyword, area): Observable<any> {
        return this.dataSource.getHospital(keyword, area);
    }

    changePassword(mobile, code, password): Observable<any> {
        return this.dataSource.changePassword(mobile, code, password);
    }


    register(data): Observable<any> {
        return this.dataSource.register(data);
    }

    getArea(area): Observable<any> {
        return this.dataSource.getArea(area);
    }

    sendSms(mobile, type): Observable<any> {
        return this.dataSource.sendSms(mobile, type);
    }

    downloadFile(type): Observable<any> {
        return this.dataSource.downloadFile(type);
    }

    login(username, password, type): Observable<any> {

        console.log(type)
        return this.dataSource.login(username, password, type);
    }



    logout(): Observable<any> {
        return this.dataSource.logout();
    }



    uploadImg(file): Observable<any> {

        return this.dataSource.uploadImg(file);
    }

    userHandle(id, type, reason): Observable<any> {

        return this.dataSource.userHandle(id, type, reason);
    }

    uploadImgForEditor(file): Observable<any> {

        return this.dataSource.uploadImgForEditor(file);
    }

    saveTrends(data): Observable<any> {

        return this.dataSource.saveTrends(data);
    }

    getTrends(): Observable<any> {

        return this.dataSource.getTrends();
    }

    publish(data, status): Observable<any> {

        return this.dataSource.publish(data, status);
    }

    getNoticeList(page): Observable<any> {

        return this.dataSource.getNoticeList(page);
    }

    getNewsList(page): Observable<any> {

        return this.dataSource.getNewsList(page);
    }

    getUserList(data, type): Observable<any> {

        return this.dataSource.getUserList(data, type);
    }

    saveCheckStatus(status, id): Observable<any> {

        return this.dataSource.saveCheckStatus(status, id);
    }


    getDataDetail(id): Observable<any> {

        return this.dataSource.getDataDetail(id);
    }

    getTableList(data): Observable<any> {

        return this.dataSource.getTableList(data);
    }

    getStatistic(data, type): Observable<any> {

        return this.dataSource.getStatistic(data, type);
    }

    getNewsType(): Observable<any> {

        return this.dataSource.getNewsType();
    }

    deleteNewsType(id): Observable<any> {

        return this.dataSource.deleteNewsType(id);
    }

    deleteNotice(id): Observable<any> {

        return this.dataSource.deleteNotice(id);
    }

    deleteNews(id): Observable<any> {

        return this.dataSource.deleteNews(id);
    }

    getMoreNews(page): Observable<any> {

        return this.dataSource.getMoreNews(page);
    }

    save(data, type): Observable<any> {

        return this.dataSource.save(data, type);
    }


    isAdministrators(): Observable<any> {

        return this.dataSource.isAdministrators();
    }

}